import { Controller } from "@hotwired/stimulus"
import intlTelInput from "intl-tel-input/intlTelInputWithUtils"

const COUNTRY_ORDER = ["ca", "us", "fr", "gb", "ci", "sn", "ma", "ng", "gh", "ke", "za", "be", "ch", "de", "es", "it", "nl"]

export default class extends Controller {
  static targets = ["country", "number"]
  static values = { country: String }

  connect() {
    this.beforeSubmit = this.beforeSubmit.bind(this)
    this.sync = this.sync.bind(this)
    this.form = this.element.closest("form")

    this.instance = intlTelInput(this.numberTarget, {
      allowDropdown: true,
      autoPlaceholder: "aggressive",
      containerClass: "push-phone-input",
      countryOrder: COUNTRY_ORDER,
      countrySearch: true,
      formatAsYouType: true,
      formatOnDisplay: true,
      initialCountry: this.initialCountry(),
      nationalMode: true,
      separateDialCode: true,
      showFlags: true,
      strictMode: true
    })

    this.numberTarget.addEventListener("countrychange", this.sync)
    this.form?.addEventListener("submit", this.beforeSubmit)
    this.sync()
  }

  disconnect() {
    this.numberTarget.removeEventListener("countrychange", this.sync)
    this.form?.removeEventListener("submit", this.beforeSubmit)
    this.instance?.destroy()
  }

  sync() {
    const country = this.instance?.getSelectedCountryData()
    if (!country?.iso2) return

    this.countryTarget.value = country.iso2.toUpperCase()
  }

  beforeSubmit() {
    this.sync()

    const number = this.instance?.getNumber()
    if (number) this.numberTarget.value = number
  }

  initialCountry() {
    return (this.countryValue || this.countryTarget.value || "CA").toLowerCase()
  }
}
